import { render, staticRenderFns } from "./detailsStatus.vue?vue&type=template&id=0cbe1556&scoped=true"
import script from "./detailsStatus.vue?vue&type=script&lang=js"
export * from "./detailsStatus.vue?vue&type=script&lang=js"
import style0 from "./detailsStatus.vue?vue&type=style&index=0&id=0cbe1556&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbe1556",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbe1556')) {
      api.createRecord('0cbe1556', component.options)
    } else {
      api.reload('0cbe1556', component.options)
    }
    module.hot.accept("./detailsStatus.vue?vue&type=template&id=0cbe1556&scoped=true", function () {
      api.rerender('0cbe1556', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P1_Girls/WithdrawalDetails/detailsStatus.vue"
export default component.exports